// extracted by mini-css-extract-plugin
export default {"base":"Details_base__+-VPd"};